module.exports = __webpack_public_path__ + "assets/registerSuccess.edb4d1ab.svg";